import { WidgetCacheAPI } from 'api'

  export const fetchById = (embedId) => {
      return WidgetCacheAPI.get(`/embeds/${embedId}`)
  }